import { useEffect } from 'react';
import { __federation_method_setRemote } from 'virtual:__federation__';
import { Remote } from '@fu-app/core';

const registerRemotes = ({ entry, name }: Remote) => {
  __federation_method_setRemote(name, {
    url: () => Promise.resolve(entry),
    format: 'esm',
    from: 'vite'
  });
};
const useDynamicRemotes = (remotes: Remote[] | undefined) => {
  useEffect(() => {
    if (!Array.isArray(remotes)) return;
    remotes.forEach(registerRemotes);
  }, [remotes]);
};

export default useDynamicRemotes;
